import React, {useState, useContext } from 'react'
import styled from "styled-components";
import MacroGraph from './macro-graph'
import MacroData from './macro-data'
import { ThemeContext } from 'styled-components'
import '../../../../../../css/tracker.sass'
import { ReactComponent as TrackerTransition } from '../../../../../../images/tracker-transition-main.svg'

const TrackerHeader = styled.div`
  background: ${(props) => props.theme.tracker.background};
  position: relative;
`;

const Macros = (props) => {
  const theme = useContext(ThemeContext)
  const [showWeeklyAvg, updateShowWeeklyAvg] = useState(false)
  const macroData = props.macroData
  const trackerData = props.trackerData
  const relatedWeighInDateString = props.relatedWeighInDateString
  const setShowConsumedMacros = props.setShowConsumedMacros
  const daysSinceLastCheckin = props.daysSinceLastCheckin
  
  return (
    <TrackerHeader>
      <div style={{padding: '16px 4px'}}>
        <MacroGraph showWeeklyAvg={showWeeklyAvg} macroData={macroData} trackerData={trackerData} relatedWeighInDateString={relatedWeighInDateString} setShowConsumedMacros={setShowConsumedMacros} daysSinceLastCheckin={daysSinceLastCheckin} vacationMode={props.vacationMode} />
        <MacroData showWeeklyAvg={showWeeklyAvg} macroData={macroData} updateShowWeeklyAvg={updateShowWeeklyAvg} trackerData={trackerData} relatedWeighInDateString={relatedWeighInDateString} vacationMode={props.vacationMode} />
      </div>
      {theme.name === 'AVATAR' && <TrackerTransition className="tracker-main-transition" />}
      {/* <img className="tracker-main-transition" src={TrackerTransition} alt="transition" /> */}
    </TrackerHeader>
  )
}

export default Macros
